// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_products_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Two products. One technology.`
};

const el_tech_products_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Δύο προϊόντα. Μία τεχνολογία.`
};

const ru_tech_products_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Два продукта. Одна технология.`
};

const he_tech_products_heading = /** @type {(inputs: {}) => string} */ () => {
	return `שני מוצרים. טכנולוגיה אחת.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_products_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_products_heading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_products_heading", locale)
	if (locale === "en") return en_tech_products_heading(inputs)
	if (locale === "el") return el_tech_products_heading(inputs)
	if (locale === "ru") return ru_tech_products_heading(inputs)
	if (locale === "he") return he_tech_products_heading(inputs)
	return "tech_products_heading"
};